import { LoadingButton } from "@mui/lab";
import {
  Alert,
  Box,
  Grid,
  TextField,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { useFormik } from "formik";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { createMultyTrayThunk } from "store/reducers/vending";

import * as yup from "yup";

const validation = yup.object({
  count: yup
    .number("Enter total number of cabins in this machine")
    .required("Username required")
    .positive()
    .min(1),
});

const MultyTrayCreateForm = ({ cabin, setTrayStepCompleted, fullGrid }) => {
  const isFullWidth = useMediaQuery((theme) => theme.breakpoints.down("md"));
  const vendingState = useSelector((state) => state.vending);
  const dispatch = useDispatch();
  const formik = useFormik({
    initialValues: {
      count: 1,
    },
    validationSchema: validation,
    onSubmit: (data) => {
      data["cabin"] = cabin.id;
      console.log(data);
      dispatch(createMultyTrayThunk(data));
    },
  });

  useEffect(() => {
    if (vendingState.createMultyTraySuccess[cabin.id]) {
      if (setTrayStepCompleted) {
        setTrayStepCompleted(true);
      }
    }
  }, [cabin, setTrayStepCompleted, vendingState.createMultyTraySuccess]);
  return (
    <Box marginTop={3}>
      <form onSubmit={formik.handleSubmit}>
        <Grid container columnSpacing={2} rowSpacing={0}>
          <Grid item xs={12} md={fullGrid ? 12 : 6} lg={fullGrid ? 12 : 4}>
            <Box
              display="flex"
              flexDirection="row"
              justifyItems="center"
              alignItems="center"
            >
              <Typography
                variant="subtitle1"
                color="gray"
                sx={{ flexShrink: 0 }}
              >
                Cabin {cabin.number}
              </Typography>

              <TextField
                label="Enter tray count"
                variant="outlined"
                name="count"
                type="number"
                fullWidth
                sx={{ ml: 1 }}
                value={formik.values.count}
                onChange={formik.handleChange}
                error={Boolean(formik.errors.count)}
                helperText={formik.errors.count}
                autoComplete="new-password"
                required
              />
              <LoadingButton
                loading={vendingState.createCabinLoading ?? false}
                variant="outlined"
                type="submit"
                disabled={
                  vendingState.createMultyTraySuccess[cabin.id] ?? false
                }
                sx={{ ml: 1 }}
              >
                Set
              </LoadingButton>
            </Box>
            {(vendingState.createMultyTrayError[cabin.id] ?? false) && (
              <Alert sx={{ mt: 3 }} severity="error">
                Error occurred
              </Alert>
            )}
            {vendingState.createMultyTraySuccess[cabin.id] && (
              <Alert sx={{ mt: 3 }} severity="success">
                Success
              </Alert>
            )}
          </Grid>
        </Grid>
      </form>
    </Box>
  );
};

export default MultyTrayCreateForm;
